import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import colorConfigs from "../../../../configs/colorConfigs";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Dialog, DialogContent } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import Webcam from "react-webcam";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import axois from "../../../../configs/axois";
import { handleCapture } from "../../../../utils/covertTheBase64FormatIntoImage";
import Editor from "../../../../components/codeEditor/Editor";
import { delete_EmailTemplate, getEmailTemplateById, put_EmailTemplate } from "../../../../services/emailTemplate";
import { validateMin } from "../../../../utils/validateMin";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../../components/hooks/useGeneral";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import { DoesEmailTemplateTypeExist } from "../../../../services/emailTemplate";
import { getEmailTemplateTypes } from "../../../../services/emailTemplateType";
import useDelete from "../../../../components/hooks/useDelete";
import EmailValidatedComponent from "../../../../components/EmailValidatedComponent";
import useAuth from "../../../../components/hooks/useAuth";
import { CustomImagePopup } from "../../../../components/common/CustomImagePopup";
import { put_fileUpload } from "../../../../services/appFileUpload";
import useConfirm from "../../../../components/hooks/useConfirm";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export default function EditEmailTemplate() {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const idNumber = useLocation();
  const { dateFormat }: any = useGeneral();
  const navigate = useNavigate();
  const [branchId, setBranchId] = useState<string>("");
  const [vehicleClassId, setVehicleClassId] = useState<string>("");
  const [itemTypeIdOld, setItemTypeIdOld] = useState<string>("0");
  const [newFilePath, setNewFilePath] = useState<string[]>([])
  const [imagePopup, setImagePopup] = useState<boolean>(false);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [showWebcam, setShowWebcam] = useState<boolean>(false);

  const [label, setLabel] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [pickupLocations, setPickupLocations] = useState<string>("");
  const [pickupLocationsOptions, setPickupLocationsOptions] = useState([]);
  const [
    pickupLocationsOptionsOfParticular,
    setPickupLocationsOptionsOfParticular,
  ] = useState([]);
  const [returnLocations, setReturnLocations] = useState<string>("");
  const [returnLocationsOptions, setReturnLocationsOptions] = useState([]);
  const [
    returnLocationsOptionsOfParticular,
    setReturnLocationsOptionsOfParticular,
  ] = useState([]);
  const [pickupLocationId, setPickupLocationId] = useState<string>("");
  const [returnLocationId, setReturnLocationId] = useState<string>("");
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [vehicleClassesOptionsOfParticular, setVehicleClassesOptionsOfParticular] = useState([]);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  const [group, setGroup] = useState<string>("");
  const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
  const [isFilters, setIsFilters] = useState<boolean>(true);
  const [sendAfterXDays, setSendAfterXDays] = useState<string>("");
  const [repeatEveryXDays, setRepeatEveryXDays] = useState<string>("");
  const [attachments, setAttachments] = useState<string>("");
  const [itemTypeId, setItemTypeId] = useState<string>("0");
  const [showItemTypeWarning, setShowItemTypeWarning] = useState<boolean>(false);
  const [isAdvanced, setIsAdvanced] = useState<boolean>(true);
  const [isContent, setIsContent] = useState<boolean>(true);
  const [hourToSend, setHourToSend] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [cc, setCc] = useState<string>("");
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [replyTo, setReplyTo] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [active, setActive] = useState<string>("No");
  const [sendAsSms, setSendAsSms] = useState<string>("No");
  const [content, setContent] = useState<string>("");
  const [filePath, setFilePath] = useState<any[]>([]);
  const [isImageSaved, setIsImageSaved] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          const newFilePath: any = {
            id: 0,
            fileName:
              `${baseURL}commonFile/Get?name=` +
              response.data,
          };
          setNewFilePath((prevPath: string[]) => [
            ...prevPath,
            newFilePath.fileName,
          ]);
          setFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }
  };


  const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);
      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {

          put_fileUpload({
            id,
            attributeName: "EmailTemplate",
            attributeId: idNumber?.state,
            fileName: response.data,
            tabName: "EmailTemplate",
            userId: auth?.id ?? 0,
            createdDate: new Date()
          }, auth?.id, tenantId)
            .then(() => {
              setFilePath((prevPath: any[]) =>
                prevPath.map(file =>
                  file.id === id ? {
                    ...file, fileName: `${baseURL}commonFile/Get?name=` +
                      response.data,
                  } : file
                )
              );
              setPleaseWaitPopup(false);
              handleTenantError(null);
            })
            .catch((error) => {
              const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
              setConfirmData({
                title: 'Warning',
                summary: errorMessage,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                }
              });
              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              handleTenantError(error);
            })
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }


  }

  useEffect(() => {
    getEmailTemplateTypes(tenantId)
      .then((res) => {
        const data = res?.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        const options = data.slice();
        options.unshift({ value: 0, label: "None" });

        setItemTypeOptions(options);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranches(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item.branchName };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleClass`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        const formattedVehicleClasses = response.data.map((item: any) => ({
          value: item.id,
          label: item.name,
          branchId: item.branchId,
        }));

        setVehicleClassesOptions(formattedVehicleClasses);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (branchId && vehicleClassesOptions)
      setVehicleClassesOptionsOfParticular(() =>
        vehicleClassesOptions.filter((item: any) => item.branchId === parseInt(branchId))
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, vehicleClassesOptions]);

  useEffect(() => {
    axios
      .get(`${baseURL}location`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        const formattedLocations = response.data.map((item: any) => ({
          value: item.id,
          label: item.locationName,
          branchId: item.branchId,
        }));

        setPickupLocationsOptions(formattedLocations);
        setReturnLocationsOptions(formattedLocations);

        if (branchId) {
          const filteredPickupLocations = formattedLocations.filter(
            (item: any) => item.branchId === parseInt(branchId)
          );
          setPickupLocationsOptionsOfParticular(filteredPickupLocations);

          const filteredReturnLocations = formattedLocations.filter(
            (item: any) => item.branchId === parseInt(branchId)
          );
          setReturnLocationsOptionsOfParticular(filteredReturnLocations);

          const defaultPickup = filteredPickupLocations.find(
            (item: any) => item.value === pickupLocationId
          );
          const defaultReturn = filteredReturnLocations.find(
            (item: any) => item.value === returnLocationId
          );

          if (defaultPickup) {
            setPickupLocations(defaultPickup.value);
          } else if (filteredPickupLocations.length > 0) {
            setPickupLocations(filteredPickupLocations[0].value);
          }

          if (defaultReturn) {
            setReturnLocations(defaultReturn.value);
          } else if (filteredReturnLocations.length > 0) {
            setReturnLocations(filteredReturnLocations[0].value);
          }
        }
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!showItemTypeWarning) {
      setPleaseWaitPopup(true);

      if (newFilePath.length !== 0) {
        newFilePath.forEach((item: string, index: number) => {
          axios
            .post(
              `${baseURL}fileUploadData?userId=${auth?.id}`,
              JSON.stringify({
                attributeName: "EmailTemplate",
                attributeId: idNumber?.state,
                fileName: item.replace(
                  `${baseURL}commonFile/Get?name=`,
                  ""
                ),
                tabName: "EmailTemplate",
                userId: 1,
                createdDate: new Date(),
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              if (newFilePath.length - 1 === index) {
                setIsImageSaved(true);
                setPleaseWaitPopup(false);
              }
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWaitPopup(false);
              handleTenantError(error);
            });
        });
      } else {
        setIsImageSaved(true);
        setPleaseWaitPopup(false);
      }
    }
  };

  useEffect(() => {
    setPleaseWaitPopup(true);
    if (isImageSaved) {
      put_EmailTemplate({
        id: idNumber?.state,
        branchId,
        name: label,
        emailTemplateTypeId: itemTypeId,
        sendAsSMS: sendAsSms === "Yes",
        group,
        vehicleClassId,
        pickupLocationId: pickupLocations,
        returnLocationId: returnLocations,
        sendAfterXDays,
        hourToSend,
        attachments,
        startDate,
        repeatEvery: repeatEveryXDays,
        isActive: active === "Yes",
        emailCC: cc,
        emailReplyTo: replyTo,
        emailSubject: subject,
        emailContent: content
      }, auth?.id, tenantId)
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });

      setIsImageSaved(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isImageSaved]);

  useEffect(() => {
    setPleaseWaitPopup(true);
    getEmailTemplateById(idNumber?.state, tenantId)
      .then((data) => {
        setBranchId(data?.branchId);
        setLabel(data?.name);
        setItemTypeId(data?.emailTemplateTypeId);
        setItemTypeIdOld(data?.emailTemplateTypeId);
        setSendAsSms(data?.sendAsSMS ? "Yes" : "No");
        setGroup(data?.group);
        setVehicleClassId(data?.vehicleClassId);
        setPickupLocationId(data?.pickupLocationId);
        setReturnLocationId(data?.returnLocationId);
        setSendAfterXDays(data?.sendAfterXDays);
        setHourToSend(data?.hourToSend);
        setAttachments(data?.attachments);
        setStartDate(data?.startDate?.split("T")[0]);
        setRepeatEveryXDays(data?.repeatEvery);
        setActive(data?.isActive ? "Yes" : "No");
        setCc(data?.emailCC);
        setReplyTo(data?.emailReplyTo);
        setSubject(data?.emailSubject);
        setContent(data?.emailContent);
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber]);

  useEffect(() => {
    axois
      .get(`${baseURL}fileUploadData/GetFileUploadDatasByAttribute?attributeName=EmailTemplate&attributeId=${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setFilePath(() =>
          response.data.map((item: any) => {
            return {
              id: item.id,
              fileName: item.fileName.startsWith("data:image/png;base64,")
                ? item.fileName
                : `${baseURL}commonFile/Get?name=` +
                item.fileName,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteEmailTemplate = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Email Template?`,
      isDelete: (callback: any) => {
        setPleaseWaitPopup(true);

        delete_EmailTemplate(idNumber?.state, auth?.id, tenantId)
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            callback();
            handleTenantError(error);
          });
      }
    });

    setDeletePopup(true);
  };

  const onItemTypeChange = (itemType: any) => {
    if (itemType) {
      if (parseInt(itemType?.value) > 0) {
        setItemTypeId(itemType?.value);

        if (parseInt(itemType?.value) === parseInt(itemTypeIdOld)) {
          setShowItemTypeWarning(false);
        } else {
          DoesEmailTemplateTypeExist(parseInt(itemType?.value), tenantId)
            .then((data) => {
              setShowItemTypeWarning(data);
              handleTenantError(null);
            })
            .catch((error) => {
              setShowItemTypeWarning(false);
              handleTenantError(error);
            });
        }
      } else {
        setShowItemTypeWarning(false);
        setItemTypeId("0");
      }
    } else {
      setShowItemTypeWarning(false);
      setItemTypeId("0");
    }
  }

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Email Template</h2>
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                      onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
                    >
                      {isGeneralSettings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div className="w-full flex flex-row justify-between items-center">
                        <div style={{ color: themeStyles.topBar.textColor }}>General Settings</div>
                      </div>
                    </h5>
                    <hr />

                    {isGeneralSettings &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={label}
                              disabled={disabled}
                              onChange={(e) => setLabel(e.target.value)}
                              required
                            />
                          </div>

                          <div className="mt-4">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Send As SMS</label>
                            <RadioGroup
                              row
                              value={sendAsSms}
                              onChange={(e) => setSendAsSms(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Item Type</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={false}
                              name="season"
                              value={itemTypeOptions.find(
                                (item: any) => item.value === itemTypeId
                              )}
                              onChange={onItemTypeChange}
                              options={itemTypeOptions}
                              required
                            />

                            {showItemTypeWarning && (
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '0.25rem',
                                fontSize: '0.75rem',
                                color: '#ff3333'
                              }}>
                                <span>Email Template is already created for this item type</span>
                              </div>
                            )}
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Group</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={group}
                              disabled={disabled}
                              onChange={(e) => setGroup(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none mt-5"
                      onClick={() => setIsFilters(!isFilters)}
                    >
                      {isFilters ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div className="w-full flex flex-row justify-between items-center">
                        <div style={{ color: themeStyles.topBar.textColor }}>Filters</div>
                      </div>
                    </h5>
                    <hr className="mb-2" />

                    {isFilters &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={branchId}
                              disabled={disabled}
                              onChange={(e) => setBranchId(e.target.value)}
                            >
                              {branches?.map((role: any, index: number) => (
                                <option key={index} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Pickup Location</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={pickupLocations}
                              disabled={disabled}
                              onChange={(e) => setPickupLocations(e.target.value)}
                            >
                              {(pickupLocationsOptionsOfParticular.length > 0 ? pickupLocationsOptionsOfParticular : pickupLocationsOptions).map(
                                (location: { value: string; label: string }) => (
                                  <option key={location.value} value={location.value}>
                                    {location.label}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Classes</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleClassId}
                              disabled={disabled}
                              onChange={(e) => setVehicleClassId(e.target.value)}
                            >
                              {vehicleClassesOptionsOfParticular.map((item: any) => (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Location</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={returnLocations}
                              disabled={disabled}
                              onChange={(e) => setReturnLocations(e.target.value)}
                            >
                              {(returnLocationsOptionsOfParticular.length > 0 ? returnLocationsOptionsOfParticular : returnLocationsOptions).map(
                                (location: { value: string; label: string }) => (
                                  <option key={location.value} value={location.value}>
                                    {location.label}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                    <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none mt-5"
                      onClick={() => setIsAdvanced(!isAdvanced)}
                    >
                      {isAdvanced ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div className="w-full flex flex-row justify-between items-center">
                        <div style={{ color: themeStyles.topBar.textColor }}>Advanced</div>
                      </div>
                    </h5>
                    <hr className="mb-2" />

                    {isAdvanced &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Send After x Days</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={sendAfterXDays}
                              disabled={disabled}
                              onChange={(e) => setSendAfterXDays(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Attachments</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={attachments}
                              disabled={disabled}
                              onChange={(e) => setAttachments(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Date</label>
                            <CustomFormatDatePicker
                              value={startDate}
                              onChange={setStartDate}
                              dateFormat={dateFormat}
                              disabled={disabled}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Repeat Every x Days</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={repeatEveryXDays}
                              disabled={disabled}
                              onChange={(e) => setRepeatEveryXDays(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Hour to Send</label>
                            <input
                              type="time"
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={hourToSend}
                              disabled={disabled}
                              onChange={(event) =>
                                setHourToSend(event.target.value)
                              }
                              required
                            />
                          </div>

                          <div className="mt-4">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={active}
                              onChange={(e) => setActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    }

                    <h5 className="mt-4 flex justify-start items-center cursor-pointer select-none"
                      onClick={() => setIsContent(!isContent)}
                    >
                      {isContent ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}{" "}
                      <div className="w-full flex flex-row justify-between items-center">
                        <div style={{ color: themeStyles.topBar.textColor }}>Content</div>
                      </div>
                    </h5>
                    <hr />
                    {
                      isContent &&
                      <div>
                        <div className="grid grid-cols-3 gap-6">
                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>CC</label>
                              <EmailValidatedComponent
                                text={cc}
                                setText={setCc}
                                required={true}
                                disabled={disabled}

                              />
                            </div>

                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Subject</label>
                              <input
                                type="text"
                                className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={subject}
                                disabled={disabled}
                                onChange={(e) => setSubject(e.target.value)}
                                required
                              />
                            </div>
                          </div>

                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Reply To</label>
                              <EmailValidatedComponent
                                text={replyTo}
                                setText={setReplyTo}
                                required={true}
                                disabled={disabled}

                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Content</label>
                          <br />
                          <Editor
                            htmlCode={content}
                            setHTMLCode={setContent}
                          />
                        </div>

                        <div className="mt-2">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Attachments</label>
                          <br />
                          {filePath.length !== 0 && (
                            <div className="flex flex-row items-center gap-[5px]">
                              {filePath.map((item: any, outerIndex: number) => {
                                return (
                                  <>
                                    <img
                                      src={item?.fileName}
                                      width={40}
                                      height={40}
                                      alt="repairOrder"
                                      onClick={() => {
                                        setFileIndex(outerIndex);
                                        setImagePopup(true);
                                      }}
                                    />
                                    <RemoveCircleIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: colorConfigs.topbar.bg,
                                        fontWeight: "bold",
                                        "&: hover": {
                                          color: "red",
                                        },
                                      }}
                                      onClick={() => {
                                        setDeleteData({
                                          id: 0,
                                          tilte: `Delete`,
                                          summary: `Are you sure you want to delete this image?`,
                                          isDelete: (callback: any) => {
                                            let newFileSet: any[] = filePath.filter(
                                              (_, index: number) => index !== outerIndex
                                            );
                                            setFilePath(() => newFileSet);

                                            callback()
                                          }
                                        });

                                        setDeletePopup(true);
                                      }}
                                    />
                                  </>
                                );
                              })}
                            </div>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputFileRef}
                            onChangeCapture={onFileChangeCapture}
                            style={{ display: "none" }}
                            disabled={disabled}
                          />
                          <div className="flex flex-row gap-2 mt-2">
                            <p
                              className="border border-dashed border-black rounded-sm px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                              onClick={(e) => {
                                if (inputFileRef.current !== null) {
                                  inputFileRef.current?.click();
                                }
                              }}
                            >
                              {" "}
                              <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                              Add Image
                            </p>

                            <p
                              className={`border border-dashed border-black rounded-sm px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white`}
                              onClick={() => { if (!disabled) setShowWebcam(true) }}
                            >
                              {" "}
                              <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                            </p>
                          </div>
                        </div>
                      </div>
                    }

                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit">
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteEmailTemplate}>
                        Delete
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      </div >

      <Dialog
        open={showWebcam}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
          />

          <div className={`w-full h-[50px] flex flex-row justify-between px-4 py-2 ${themeStyles.main.tailwindSectionBg}`}>
            <div className="w-1/2">
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setShowWebcam(false)}>
                Cancel
              </Button>
            </div>

            <div className="w-1/2 flex flex-row justify-end">
              <Button
                variant="contained"
                sx={{ backgroundColor: colorConfigs.btn.main.bg }}
                onClick={() => {
                  if (webRef.current !== null) {
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}commonFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFilePath((prevFileString: any[]) => [
                          ...prevFileString,
                          {
                            id: 0,
                            fileName: `${baseURL}commonFile/Get?name=${imageFilePath}`,
                          }
                        ]);
                      }
                    })

                    setShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>


      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={filePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="commonFile"
        updateFile={updateFile}
      />

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
